import httpService from '@/services/httpService'
// eslint-disable-next-line no-unused-vars
import Calendar from '../../../features/calendar/index.vue'

export const types = {
  ADD_CALENDAR_SESSION: 'rank-zone/ADD_CALENDAR_SESSION',
  ADD_CALENDAR_RESET_SESSION: 'rank-zone/ADD_CALENDAR_RESET_SESSION',
  ADD_CALENDAR_UPDATING_STATUS: 'rank-zone/ADD_CALENDAR_UPDATING_STATUS'
}
const emptyData = {
  calendar: { events: [], links: [], urls: [] },
  startDate: null,
  endDate: null,
  isDataUpdating: true
}

const state = { ...emptyData, isDataUpdating: true }

const mutations = {
  [ types.ADD_CALENDAR_SESSION ]: function (state, { events, links, urls, startDate, endDate }) {
    state.calendar.events = events || []
    state.calendar.links = links || []
    state.calendar.urls = urls || []
    state.startDate = startDate
    state.endDate = endDate
  },
  [types.ADD_CALENDAR_UPDATING_STATUS]: function (state, status) {
    state.isDataUpdating = status
  },
  [types.ADD_CALENDAR_RESET_SESSION]: function (state) {
    state.calendar = { ...emptyData }
  }
}
const actions = {

  getCalendar: async function ({ commit, dispatch }, { clientId, filters }) {
    const params = { ...filters }
    commit(types.ADD_CALENDAR_UPDATING_STATUS, true)
    dispatch('resetData')
    const response = await httpService.get(`/calendar/events/${clientId}`, { params })
    if (response && response.data) {
      commit(types.ADD_CALENDAR_SESSION, {
        events: response.data.events,
        links: response.data.links,
        urls: response.data.urls,
        startDate: response.data.start_date,
        endDate: response.data.end_date
      })
    }
    commit(types.ADD_CALENDAR_UPDATING_STATUS, false)
  },
  changeEvent: function ({ commit }, { clientId, eventId, end_date = null,
    start_date = null, type, description = null, name = null, page_type = null, status = null }) {
    function getMessage (type = 'event') {
      if (type === 'event') {
        return 'Event updated successfully'
      }
      if (type === 'link') {
        return 'Link updated successfully'
      }
      if (type === 'url') {
        return 'URL updated successfully'
      }
    }

    const params = {event_id: eventId, type, end_date, start_date, description, name, page_type, status}
    const successMessage = getMessage(type)
    return httpService.patch(`/calendar/change-event/${clientId}`, params, { successMessage })
  },
  createEvent: function ({ commit }, { clientId, start_date = null, end_date = null, description = null, name }) {
    const params = { start_date, end_date, description, name }
    return httpService.post(`/calendar/create-event/${clientId}`, params, { successMessage: 'Event created successfully', raiseError: true })
  },
  resetData: function ({ commit }) {
    commit(types.ADD_CALENDAR_SESSION, emptyData)
  },
  deleteEvent({ commit }, { clientId, eventId}) {
    const params = { event_id: eventId }
    return httpService.delete(`/calendar/delete-event/${clientId}`, { params, successMessage: 'Event deleted successfully', raiseError: true })
  }
}

/**
 * Store keep data for {@link Calendar} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
